// extracted by mini-css-extract-plugin
export var actions = "_co-g";
export var benefitCard = "_co-b";
export var benefitIcon = "_co-d";
export var benefitLabel = "_co-f";
export var benefits = "_co-a";
export var benefitsSection = "_co-8";
export var bodyText = "_co-7";
export var closeButton = "_co-2";
export var content = "_co-3";
export var eyebrow = "_co-4";
export var heading = "_co-5";
export var image = "_co-i";
export var imagePanel = "_co-h";
export var modal = "_co-0";
export var offerCard = "_co-c";
export var offerIcon = "_co-e";
export var sectionLabel = "_co-9";
export var shell = "_co-1";
export var title = "_co-6";